import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings'
import { StaticRoutes } from 'common/routing/page-definition'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

const customSportTopicForAds = {
    id: 'sport/cricket',
    title: 'Cricket',
    parent: { id: 'sport', title: 'Sport', metadata: {}, seoTitle: 'Sport' },
    metadata: {},
    seoTitle: 'Cricket',
}

export const liveScoresRoute: StaticRoutes<typeof layout, TheWestSection> = {
    '/sport/cricket/live-scores': ({ getAdTargeting }) => ({
        kind: 'page',
        heading: 'Cricket Live Scores',
        hideHeading: true,
        pageType: 'static',
        pageMeta: {
            title: 'Cricket Live Scores',
            description: 'Cricket Live Scores for The West Australian',
        },
        noMetaTitleTemplate: true,
        adTargeting: getAdTargeting(
            'live-scores',
            'lifestyle',
            'live-scores',
            customSportTopicForAds
        ),
        section: 'default',
        compositions: [
            {
                type: 'box',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    verticalGutters: ['outerMargin', 'unset'],
                    horizontalGutters: 'outerMargin',
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'breadcrumb',
                            props: {
                                title: 'Cricket Live Scores',
                                enableHeaderTag: true,
                            },
                        }),
                    ],
                },
            },
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'livescores',
                                        props: {
                                            url:
                                                'https://thewest-ckt-scoreboard.sportsflash.com.au',
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: metrics.thewest.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: true,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: false,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'lima',
                                        props: {
                                            verticalSpacing: 'lg',
                                            fontScale: 1.2,
                                            fixedRatios: ['16:9'],
                                            hasBackground: true,
                                            hideTeaser: true,
                                            loadMoreEnabled: true,
                                            initialColumns: 1,
                                            intermediateColumns: 2,
                                            finalColumns: 4,
                                            cardOrientation: { type: 'Landscape-Portrait' },
                                            sectionHeader: {
                                                heading: 'Latest Cricket News',
                                                section: 'sport',
                                            },
                                            dataDefinitionArgs: {
                                                type: 'listing',
                                                topics: ['sport/cricket'],
                                                includeSubTopics: false,
                                                paging: {
                                                    page: 1,
                                                    pageSize: 8,
                                                },
                                            },
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }),
}
